import { render } from "./BookingExtrasModalCase3.vue?vue&type=template&id=017552c2"
import script from "./BookingExtrasModalCase3.vue?vue&type=script&lang=js"
export * from "./BookingExtrasModalCase3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingExtrasModalCase3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "017552c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('017552c2', __exports__)) {
    api.reload('017552c2', __exports__)
  }
  
  module.hot.accept("./BookingExtrasModalCase3.vue?vue&type=template&id=017552c2", () => {
    api.rerender('017552c2', render)
  })

}


export default __exports__